import { tv } from 'tailwind-variants';

const baseLabelStyles = tv({
    base: `
    iris:cursor-pointer
    iris:outline-none
    iris:aria-disabled:cursor-not-allowed
    iris:aria-disabled:opacity-(--sem-opacity-interactive-disabled)
  `,
    variants: {
        variant: {
            default: `
        iris:text-(length:--comp-type-size-input-label)
        iris:leading-(--comp-type-leading-input-label)
        iris:font-(--comp-type-weight-input-label)
        iris:tracking-(--comp-type-tracking-input-label)
      `,
            inner: `
        iris:text-(length:--comp-type-size-input-helper)
        iris:leading-(--comp-type-leading-input-helper)
        iris:font-(--comp-type-weight-input-helper)
        iris:tracking-(--comp-type-tracking-input-helper)
      `,
        },
        inverse: {
            false: `
        iris:text-(--comp-color-content-input-label-rest)
        iris:hover:text-(--comp-color-content-input-label-hover)
        iris:focus:text-(--comp-color-content-input-label-active)
      `,
            true: `
        iris:text-(--comp-color-content-input-label-inverse-rest)
        iris:hover:text-(--comp-color-content-input-label-inverse-hover)
        iris:focus:text-(--comp-color-content-input-label-inverse-active)
      `,
        },
    },
});

export { baseLabelStyles as default };
